// extracted by mini-css-extract-plugin
export default {"navigationButtonBackIcon":"NavigationButtons-module__navigationButtonBackIcon--fa0Yd","navigationButtonNextIcon":"NavigationButtons-module__navigationButtonNextIcon--Vgtek"};